export default __webpack_public_path__ + "static/media/pcard2.a4b4a1ca.webp";